import type { ReactElement } from 'react';

import { Tooltip as BaseTooltip, type TooltipPopupProps, type TooltipRootProps, type TooltipTriggerProps } from '@base-ui/react';

import { useCollisionPadding } from '~/hooks/useCollisionPadding';

import { ArrowSvg } from '../Infotip/Infotip';
import { arrowPopupStyle, popupStyle, positionerStyle } from '../Infotip/Infotip.css';

type Props = TooltipRootProps & {
  children: ReactElement;
  content: TooltipPopupProps['children'];
  triggerId?: TooltipTriggerProps['id'];
};

export const Tooltip = ({ children, content, triggerId, ...delegated }: Props) => {
  const collisionPadding = useCollisionPadding();

  if (!content) return children;

  return (
    <BaseTooltip.Root {...delegated}>
      <BaseTooltip.Trigger id={triggerId} render={children} />

      <BaseTooltip.Portal>
        <BaseTooltip.Positioner className={positionerStyle} collisionPadding={collisionPadding} side="top" sideOffset={8}>
          <BaseTooltip.Popup className={popupStyle}>
            <BaseTooltip.Arrow className={arrowPopupStyle}>
              <ArrowSvg />
            </BaseTooltip.Arrow>

            {content}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
};
